import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGameState } from './GameStateContext';
import AxeImage from './Axe.png';
import MetalAxeImage from './MetalAxe.png';

const Marketplace = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        scraps,
        addToInventory,
        buyAxe,
        equipAxe,
    } = useGameState();
    const [backgroundColor] = useState(location.state?.backgroundColor || '#FF973E');
    useEffect(() => {
        // Update the background color of the entire page
        document.body.style.backgroundColor = backgroundColor;
    }, [backgroundColor]);

    const [purchaseMessage, setPurchaseMessage] = useState('');

    const handleBuyAxe = (axeType) => {
        const newAxe = buyAxe(axeType);
        if (newAxe) {
            addToInventory(newAxe);
            setPurchaseMessage(`${axeType} Axe purchased successfully!`);
        } else {
            setPurchaseMessage(`Not enough SCRAPS to buy a ${axeType} Axe.`);
        }
    };

    const handleEquipAxe = (axeType) => {
        const success = equipAxe(axeType);
        if (success) {
            setPurchaseMessage(`${axeType} Axe equipped!`);
        } else {
            setPurchaseMessage(`No ${axeType} Axe available to equip.`);
        }
    };

    const exitMarketplace = () => {
        // Pass back the current axe hit points
        navigate('/game', { state: { backgroundColor, newAxeHitPoints: location.state?.axeHitPoints || 30 } });
    };

    return (
        <div
            style={{
                backgroundColor: backgroundColor,
                height: '100vh',
                textAlign: 'center',
                fontFamily: 'Dirty Brush',
            }}
        >
            <h1>Marketplace</h1>
            <div>Your Scraps: <span className="number-display">{scraps}</span></div>
            <div
                style={{
                    position: 'fixed',
                    bottom: '310px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    cursor: 'pointer',
                    fontSize: '20px', // Adjust font size for better mobile visibility
                    padding: '10px', // Add some padding for better touch interaction
                    backgroundColor: '#ccc', // Optional: background color for the button
                    borderRadius: '5px', // Optional: round the corners of the button
                }}
                onClick={exitMarketplace}
            >
                Exit
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                }}
            >
                {/* Wooden Axe */}
                <div style={{ margin: '10px' }}>
                    <img
                        src={AxeImage}
                        alt="Wooden Axe"
                        style={{ width: '100px', height: '150px' }}
                    />
                    <div>
                        Wooden Axe - Hit Points:{' '}
                        <span className="number-display">{10}</span>
                    </div>{' '}
                    {/* Display hit points */}
                    <button
                        onClick={() => handleBuyAxe('Wooden')}
                        style={{ marginTop: '10px' }}
                    >
                        Buy Wooden Axe (
                        <span className="number-display">2 SCRAPS</span>)
                    </button>
                    <button
                        onClick={() => handleEquipAxe('Wooden')}
                        style={{ marginTop: '10px' }}
                    >
                        Equip Wooden Axe
                    </button>
                </div>
                {/* Metal Axe */}
                <div style={{ margin: '10px' }}>
                    <img
                        src={MetalAxeImage}
                        alt="Metal Axe"
                        style={{ width: '100px', height: '150px' }}
                    />
                    <div>
                        Metal Axe - Hit Points:{' '}
                        <span className="number-display">{30}</span>
                    </div>{' '}
                    {/* Display hit points */}
                    <button
                        onClick={() => handleBuyAxe('Metal')}
                        style={{ marginTop: '10px' }}
                    >
                        Buy Metal Axe (
                        <span className="number-display">7 SCRAPS</span>)
                    </button>
                    <button
                        onClick={() => handleEquipAxe('Metal')}
                        style={{ marginTop: '10px' }}
                    >
                        Equip Metal Axe
                    </button>
                </div>
            </div>
            {purchaseMessage && (
                <div
                    style={{
                        marginTop: '20px',
                        color: 'black',
                        fontSize: '18px',
                    }}
                >
                    {purchaseMessage}
                </div>
            )}
        </div>
    );
};

export default Marketplace;
